import React from 'react'
import './Error.css'
const Error = () => {
  return (
    <div className='Error--background'>
      <div className='Error--container'>
        <h1 className='Error-heading'>404</h1>
        <h2>Page not found</h2>
      </div>
    </div>
  )
}

export default Error
